import largeBannerAU from "assets/images/banners/gift-cards/largeBannerAU.png";
import largeBannerEn_CA from "assets/images/banners/gift-cards/largeBannerEn_CA.png";
import largeBannerFr_CA from "assets/images/banners/gift-cards/largeBannerFr_CA.png";
import largeBannerGB from "assets/images/banners/gift-cards/largeBannerGB.png";
import largeBannerNA from "assets/images/banners/gift-cards/largeBannerNA.png";
import largeBannerNZ from "assets/images/banners/gift-cards/largeBannerNZ.png";
import smallBannerAU from "assets/images/banners/gift-cards/smallBannerAU.png";
import smallBannerCA from "assets/images/banners/gift-cards/smallBannerCA.png";
import smallBannerGB from "assets/images/banners/gift-cards/smallBannerGB.png";
import smallBannerNA from "assets/images/banners/gift-cards/smallBannerNA.png";
import smallBannerNZ from "assets/images/banners/gift-cards/smallBannerNZ.png";
import { useTranslation } from "react-i18next";

import { Locale } from "@/types/locale";

import LinkButton from "../../buttons/link-button";
import styles from "./gift-card-hero-banner.module.scss";

type BannerData = {
    large: {
        src: string;
    };
    small: {
        src: string;
    };
};

type SupportedLocale = "en-US" | "en-AU" | "en-NZ" | "en-GB" | "en-CA" | "fr-CA";

const bannerImageByRegion: Record<SupportedLocale, BannerData> = {
    "en-US": {
        large: largeBannerNA,
        small: smallBannerNA,
    },
    "en-AU": {
        large: largeBannerAU,
        small: smallBannerAU,
    },
    "en-NZ": {
        large: largeBannerNZ,
        small: smallBannerNZ,
    },
    "en-GB": {
        large: largeBannerGB,
        small: smallBannerGB,
    },
    "en-CA": {
        large: largeBannerEn_CA,
        small: smallBannerCA,
    },
    "fr-CA": {
        large: largeBannerFr_CA,
        small: smallBannerCA,
    },
};

type Props = {
    locale: Locale;
};

export const GiftCardHeroBanner = ({ locale }: Props) => {
    const { t } = useTranslation();
    const disclosure = t("giftCards.banner.disclosure");

    const localeToGiftCardLink = {
        "en-AU": "https://afterpayau.app.link/WebAU-BAU-Giftcard-herolandingpage",
        "en-GB": "https://clearpay.app.link/WebUK-BAU-Giftcard-herolandingpage",
        "en-NZ": "https://afterpayau.app.link/WebNZ-BAU-Giftcard-herolandingpage",
        "en-US": "https://afterpayus.app.link/WebUS-BAU-Giftcard-herolandingpage",
        "en-CA": "https://afterpayus.app.link/bLSxpLhGMKb",
        "fr-CA": "https://afterpayus.app.link/bLSxpLhGMKb",
    };

    if (!bannerImageByRegion[locale]) {
        return null;
    }

    return (
        <div className={styles.container}>
            <div className={styles.backgroundContainer}>
                <div
                    className={styles.backgroundLarge}
                    style={{
                        backgroundImage: `url("${bannerImageByRegion[locale].large.src}")`,
                    }}
                />
                <div
                    className={styles.backgroundSmall}
                    style={{
                        backgroundImage: `url("${bannerImageByRegion[locale].small.src}")`,
                    }}
                />
            </div>
            <div className={styles.overlayContainer}>
                <div className={styles.overlayRow}>
                    <div className={styles.overlay}>
                        <h2 className={styles.overlayHeading}>
                            {t("giftCards.banner.heading.lineOne")}
                            <br />
                            {t("giftCards.banner.heading.lineTwo")}
                        </h2>
                        <p className={styles.overlayBody}>{t("giftCards.banner.content")}</p>
                        <div className={styles.ctaContainer}>
                            <div className={styles.ctaOne}>
                                <LinkButton
                                    kind="black"
                                    label={t("giftCards.banner.buttonLabel")}
                                    size="large"
                                    url={localeToGiftCardLink[locale]}
                                />
                            </div>
                        </div>
                        {disclosure && <p className={styles.disclosureSmall}>{disclosure}</p>}
                    </div>

                    {disclosure && <p className={styles.disclosureLarge}>{disclosure}</p>}
                </div>
            </div>
        </div>
    );
};
